import Vue from "vue";
import VueRouter from "vue-router";
import SideMenu from "../layouts/SideMenu";
import SimpleMenu from "../layouts/SimpleMenu";
import TopMenu from "../layouts/TopMenu";
import Inicio from "../views/Inicio";
import Notificaciones from "../views/Notificaciones";
import Descarga from "../views/Descarga";
import Carga from "../views/Carga";
import Empresa from "../views/Empresa";
import EmpresasYCentros from "../views/EmpresasYCentros";
import Control from "../views/Control";
import Tablon from "../views/Tablon";
import Login from "../views/Login";
import ErrorPage from "../views/ErrorPage";
import store from "../store";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "login",
        meta: {
            name: "Login"
        },
        component: Login
    },
    {
        path: "/",
        component: SideMenu,
        children: [{
                path: "/",
                name: "side-menu-inicio",
                meta: {
                    name: "Inicio"
                },
                component: Inicio
            },
            {
                path: "empresa",
                name: "side-menu-empresa",
                meta: {
                    name: "Empresa"
                },
                component: Empresa
            },
            {
                path: "empresas-y-centros",
                name: "side-menu-empresas-y-centros",
                component: EmpresasYCentros,
                props: {
                    botones: 'listado',
                },
                meta: {
                    name: "Empresas y centros"
                }
            },
            {
                path: "empresa-resumen",
                name: "side-menu-empresa-resumen",
                component: EmpresasYCentros,
                props: {
                    botones: 'resumen'
                },
                meta: {
                    name: "Resumen"
                }
            },
            {
                path: "ultimos-docs",
                name: "side-menu-ultimos-docs",
                component: EmpresasYCentros,
                props: {
                    botones: 'ultimos-docs',
                },
                meta: {
                    name: "Últimos docs."
                }
            },
            {
                path: "control-docs",
                name: "side-menu-control-docs",
                component: EmpresasYCentros,
                props: {
                    botones: 'docs',
                },
                meta: {
                    name: "Documentos"
                }
            },
            {
                path: "notificaciones",
                name: "side-menu-notificaciones",
                meta: {
                    name: "Notificaciones"
                },
                component: Notificaciones
            },
            {
                path: "carga",
                name: "side-menu-carga",
                meta: {
                    name: "Área de carga"
                },
                component: Carga
            },
            {
                path: "descarga",
                name: "side-menu-descarga",
                meta: {
                    name: "Área de descarga"
                },
                component: Descarga
            },
            {
                path: "control",
                name: "side-menu-control",
                meta: {
                    name: "Control de Documentos"
                },
                component: Control
            },
            {
                path: "resumen",
                name: "side-menu-resumen",
                meta: {
                    name: "Resumen"
                },
                props: {
                    mostrar_resumen: true
                },
                component: Control
            },
            {
                path: "tablon",
                name: "side-menu-tablon",
                meta: {
                    name: "Tablón de anuncios"
                },
                component: Tablon
            },
            {
                path: "/error-page",
                name: "error-page",
                meta: {
                    name: "Error"
                },
                component: ErrorPage
            },
            {
                path: "/*",
                component: ErrorPage
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    }
});

//LOGIN HACER
router.beforeEach((to, from, next) => {
    if (to.name == "login") {
        return next();
    }

    CmsApi.hook("/hooks/login/", {}, (data) => {
        let puede_continuar;
        if (data.is_admin) {
            window.bus.admin = true;
            puede_continuar = store.state.sideMenu.admin_menu.find(e => { return e.pageName == to.name })
        } else {
            window.bus.admin = false;
            puede_continuar = store.state.sideMenu.menu.find(e => { return e.pageName == to.name })
        }
        //puede_continuar = true;
        if (data.success && data.data) window.bus.setData({ user: data.data, admin: window.bus.admin });
        window.bus.$emit('dataReloaded');
        if (!data.success || !puede_continuar) return next("login");
        next()
    });
    //next();
})

export default router;